import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { Route as AssignmentEditStrategyRoute } from '~/core/routes/settings/assignment-strategy/[strategyId]/edit/_index';
import { Route as AssignmentStrategyRoute } from '~/core/routes/settings/assignment-strategy/_index';
import { Route as AssignmentCreateStrategyRoute } from '~/core/routes/settings/assignment-strategy/new/[implementationId]/_index';

// Fragments
type AssignmentStrategyLayoutProps = { children: React.ReactNode };
const AssignmentStrategyLayout = ({
  children,
}: AssignmentStrategyLayoutProps) => <>{children}</>;

// Exports
export const permissions: PermissionsFn = (context) => {
  if (context.user.userType !== 'BORROWER') return 'deny';
  return context.flags.productsAssignmentsPermissions;
};
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/settings" replace />}
    >
      <AssignmentStrategyLayout>
        <Outlet />
      </AssignmentStrategyLayout>
    </PermissionGuard>
  ),
  // Relative to /settings/assignment-strategies/*
  children: [
    { index: true, element: <AssignmentStrategyRoute /> },
    {
      path: 'new/:implementationId',
      element: <AssignmentCreateStrategyRoute />,
    },
    {
      path: ':strategyId/edit',
      element: <AssignmentEditStrategyRoute />,
    },
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
